/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { exportD1PortfolioDashboardsD1PortfolioExcelGet } from '../fn/export/export-d-1-portfolio-dashboards-d-1-portfolio-excel-get';
import { ExportD1PortfolioDashboardsD1PortfolioExcelGet$Params } from '../fn/export/export-d-1-portfolio-dashboards-d-1-portfolio-excel-get';
import { exportD4TimeseriesDashboardsD4TimeseriesExcelGet } from '../fn/export/export-d-4-timeseries-dashboards-d-4-timeseries-excel-get';
import { ExportD4TimeseriesDashboardsD4TimeseriesExcelGet$Params } from '../fn/export/export-d-4-timeseries-dashboards-d-4-timeseries-excel-get';
import { exportD8GridDashboardsD8GridExcelGet } from '../fn/export/export-d-8-grid-dashboards-d-8-grid-excel-get';
import { ExportD8GridDashboardsD8GridExcelGet$Params } from '../fn/export/export-d-8-grid-dashboards-d-8-grid-excel-get';
import { exportD9TableDashboardsD9TableExcelGet } from '../fn/export/export-d-9-table-dashboards-d-9-table-excel-get';
import { ExportD9TableDashboardsD9TableExcelGet$Params } from '../fn/export/export-d-9-table-dashboards-d-9-table-excel-get';
import { exportUnifiedDashboardsExportGet } from '../fn/export/export-unified-dashboards-export-get';
import { ExportUnifiedDashboardsExportGet$Params } from '../fn/export/export-unified-dashboards-export-get';

@Injectable({ providedIn: 'root' })
export class BackendApiExportService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exportD9TableDashboardsD9TableExcelGet()` */
  static readonly ExportD9TableDashboardsD9TableExcelGetPath = '/dashboards/d9/table/excel';

  /**
   * D9 P&L таблица — xlsx.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportD9TableDashboardsD9TableExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD9TableDashboardsD9TableExcelGet$Response(
    params: ExportD9TableDashboardsD9TableExcelGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<any>> {
    return exportD9TableDashboardsD9TableExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D9 P&L таблица — xlsx.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportD9TableDashboardsD9TableExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD9TableDashboardsD9TableExcelGet(
    params: ExportD9TableDashboardsD9TableExcelGet$Params,
    context?: HttpContext,
  ): Observable<any> {
    return this.exportD9TableDashboardsD9TableExcelGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<any>): any => r.body),
    );
  }

  /** Path part for operation `exportD4TimeseriesDashboardsD4TimeseriesExcelGet()` */
  static readonly ExportD4TimeseriesDashboardsD4TimeseriesExcelGetPath = '/dashboards/d4/timeseries/excel';

  /**
   * D4 коэффициенты — xlsx.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportD4TimeseriesDashboardsD4TimeseriesExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD4TimeseriesDashboardsD4TimeseriesExcelGet$Response(
    params: ExportD4TimeseriesDashboardsD4TimeseriesExcelGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<any>> {
    return exportD4TimeseriesDashboardsD4TimeseriesExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D4 коэффициенты — xlsx.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportD4TimeseriesDashboardsD4TimeseriesExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD4TimeseriesDashboardsD4TimeseriesExcelGet(
    params: ExportD4TimeseriesDashboardsD4TimeseriesExcelGet$Params,
    context?: HttpContext,
  ): Observable<any> {
    return this.exportD4TimeseriesDashboardsD4TimeseriesExcelGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<any>): any => r.body),
    );
  }

  /** Path part for operation `exportD8GridDashboardsD8GridExcelGet()` */
  static readonly ExportD8GridDashboardsD8GridExcelGetPath = '/dashboards/d8/grid/excel';

  /**
   * D8 план продаж — xlsx.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportD8GridDashboardsD8GridExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD8GridDashboardsD8GridExcelGet$Response(
    params: ExportD8GridDashboardsD8GridExcelGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<any>> {
    return exportD8GridDashboardsD8GridExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D8 план продаж — xlsx.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportD8GridDashboardsD8GridExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD8GridDashboardsD8GridExcelGet(
    params: ExportD8GridDashboardsD8GridExcelGet$Params,
    context?: HttpContext,
  ): Observable<any> {
    return this.exportD8GridDashboardsD8GridExcelGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<any>): any => r.body),
    );
  }

  /** Path part for operation `exportD1PortfolioDashboardsD1PortfolioExcelGet()` */
  static readonly ExportD1PortfolioDashboardsD1PortfolioExcelGetPath = '/dashboards/d1/portfolio/excel';

  /**
   * D1 портфель проектов — xlsx (только для админов).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportD1PortfolioDashboardsD1PortfolioExcelGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD1PortfolioDashboardsD1PortfolioExcelGet$Response(
    params?: ExportD1PortfolioDashboardsD1PortfolioExcelGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<any>> {
    return exportD1PortfolioDashboardsD1PortfolioExcelGet(this.http, this.rootUrl, params, context);
  }

  /**
   * D1 портфель проектов — xlsx (только для админов).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportD1PortfolioDashboardsD1PortfolioExcelGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportD1PortfolioDashboardsD1PortfolioExcelGet(
    params?: ExportD1PortfolioDashboardsD1PortfolioExcelGet$Params,
    context?: HttpContext,
  ): Observable<any> {
    return this.exportD1PortfolioDashboardsD1PortfolioExcelGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<any>): any => r.body),
    );
  }

  /** Path part for operation `exportUnifiedDashboardsExportGet()` */
  static readonly ExportUnifiedDashboardsExportGetPath = '/dashboards/export';

  /**
   * Все дашборды одного проекта в одном xlsx (D9 + D4 + D8).
   *
   * Собирает три листа: D9 P&L, D4 финансовые коэффициенты, D8 план продаж. D1 portfolio в этот файл НЕ входит — он по смыслу касается множества проектов, экспортируется отдельной ручкой /dashboards/d1/portfolio/excel.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportUnifiedDashboardsExportGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportUnifiedDashboardsExportGet$Response(
    params: ExportUnifiedDashboardsExportGet$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<any>> {
    return exportUnifiedDashboardsExportGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Все дашборды одного проекта в одном xlsx (D9 + D4 + D8).
   *
   * Собирает три листа: D9 P&L, D4 финансовые коэффициенты, D8 план продаж. D1 portfolio в этот файл НЕ входит — он по смыслу касается множества проектов, экспортируется отдельной ручкой /dashboards/d1/portfolio/excel.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportUnifiedDashboardsExportGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportUnifiedDashboardsExportGet(
    params: ExportUnifiedDashboardsExportGet$Params,
    context?: HttpContext,
  ): Observable<any> {
    return this.exportUnifiedDashboardsExportGet$Response(params, context).pipe(
      map((r: BakendHttpResponse<any>): any => r.body),
    );
  }
}
